export enum StatusLembreteEnum {
  PENDENTE = 'PENDENTE',
  RODANDO = 'RODANDO',
  CONCLUIDO = 'CONCLUIDO',
  INATIVO = 'INATIVO',
  ERRO = 'ERRO',
}

export const STATUS_LEMBRETE_ORDINAL: Record<StatusLembreteEnum, number> = {
  [StatusLembreteEnum.PENDENTE]: 0,
  [StatusLembreteEnum.RODANDO]: 1,
  [StatusLembreteEnum.CONCLUIDO]: 2,
  [StatusLembreteEnum.INATIVO]: 3,
  [StatusLembreteEnum.ERRO]: 4,
};

export const STATUS_LEMBRETE_LABEL: Record<string, string> = {
  [StatusLembreteEnum.PENDENTE]: 'Pendente',
  [StatusLembreteEnum.RODANDO]: 'Processando',
  [StatusLembreteEnum.CONCLUIDO]: 'Concluído',
  [StatusLembreteEnum.INATIVO]: 'Excluído',
  [StatusLembreteEnum.ERRO]: 'Erro',
};
